const Footer = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5519981868997', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+5519981868997';
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-blue-400 mb-4">Atendimento 24 Horas</h3>
            <div className="bg-gray-700 rounded-lg p-4">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <div>
                  <button
                    onClick={handleCall}
                    className="text-white hover:text-blue-400 transition-colors cursor-pointer"
                  >
                    <div className="font-bold">CENTRAL DE ATENDIMENTO</div>
                    <div className="text-lg">(19) 98186-8997</div>
                  </button>
                </div>
              </div>
              <div className="text-center">
                <span className="bg-blue-600 px-3 py-1 rounded-full text-sm font-bold">
                  24 HORAS
                </span>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-4 mt-4">
              <button
                onClick={handleWhatsApp}
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                <span>Chame no WhatsApp</span>
              </button>
              <button
                onClick={handleCall}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>Ligue Agora</span>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-blue-400 mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-blue-400"></i>
                  <span>Página Inicial</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-blue-400"></i>
                  <span>Serviços</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-nos')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-blue-400"></i>
                  <span>Sobre Nós</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vantagens')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-blue-400"></i>
                  <span>Vantagens</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-blue-400"></i>
                  <span>Contato</span>
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-white mb-4">Formas de Pagamento</h3>
            <img
              alt="Formas de Pagamento - Cartão em até 10x sem juros, PIX, Dinheiro"
              className="w-full h-auto rounded"
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/6bcd51936397849bbfb5d10880a64f2a.png"
            />
            <p className="text-gray-300 text-sm mt-2">
              💳 Cartão em até 10x sem juros
              <br />
              📱 PIX com desconto
              <br />
              💵 Dinheiro à vista
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-blue-400 mb-4">Segurança e Certificações</h3>
            <div className="grid grid-cols-1 gap-4 mb-4">
              <div className="bg-gray-700 rounded-lg p-3 text-center">
                <i className="ri-shield-check-line text-2xl text-green-400 mb-2"></i>
                <div className="text-sm">Site Seguro</div>
              </div>
              <div className="bg-gray-700 rounded-lg p-3 text-center">
                <i className="ri-award-line text-2xl text-yellow-400 mb-2"></i>
                <div className="text-sm">Certificado</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-900 py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="flex items-center space-x-4">
              <img
                alt="Desentupidora da Cidade Nº1"
                className="w-16 h-16 object-contain"
                src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/7b868c287da1d35a6e81793ece1ec769.png"
              />
              <div>
                <h4 className="text-2xl font-bold">Desentupidora da Cidade Nº1</h4>
                <p className="text-gray-300">
                  Temos uma equipe profissional pronta para atender você 24 horas por dia, inclusive
                  sábados, domingos e feriados.
                </p>
              </div>
            </div>

            <div className="text-center lg:text-right">
              <div className="space-y-2">
                <div className="text-lg font-semibold">Entre em contato:</div>
                <div className="flex items-center justify-center lg:justify-end space-x-4">
                  <button
                    onClick={handleCall}
                    className="flex items-center space-x-2 text-blue-400 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-phone-line"></i>
                    <span>(19) 98186-8997</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
            <div className="flex items-center space-x-4 mb-2 md:mb-0">
              <span>© 2024 - Desentupidora da Cidade Nº1 - Atendimento 24 horas</span>
              <span>•</span>
              <span>Chegamos em 30 minutos</span>
              <span>•</span>
              <span>Melhores Preços</span>
            </div>
            <div>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-white transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;